import React from 'react';
import {connect} from "react-redux";
import Field from './Field';
import {setClearResults} from '../actions/filters';
import ClearButton from "./common/ClearButton";

const Metrika=({metrika, filters, dispatch})=>{
    if(metrika===undefined)return null;
    return <div>
    <ClearButton panel='metrika'/>
    <div className='metrika-container'>
            {Object.keys(metrika)
                .filter((key)=>(key!=='from'))
                .map((key)=>(
                        <div className='metrika-item' key={key}>
                            <Field object={metrika} field={key} key={key}/>
                        </div>))}
    </div></div>
};

const mapStateToProps=(state)=>({metrika:state.data.metrika, filters: state.filters});
const ConnectedMetrika=connect(mapStateToProps)(Metrika);
export default ConnectedMetrika;